<mat-card class="transparent-card">
    <mat-card-header>
        <mat-card-title>Settings</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-card class="workspace-status-info" *ngIf="!hasSubscription">
        <mat-card-content>
          <h1>Workspace Deactivated</h1>
          <p>You currently don’t have an active subscription. To continue using your workspace, please <a target="_blank" href="https://liumex.com/contact">reach out to us</a>!</p>
        </mat-card-content>
      </mat-card>
      <table mat-table class="transparent-table" [dataSource]="workspaceSource">
          <ng-container matColumnDef="info">
              <td mat-cell *matCellDef="let data">{{ data.info }}</td>
            </ng-container>
            <ng-container matColumnDef="value">
              <td mat-cell *matCellDef="let data">
                <mat-spinner *ngIf="data.loading"></mat-spinner>
                <span *ngIf="!data.loading">{{ data.value }}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="edit">
              <td mat-cell *matCellDef="let data">
                  <mat-spinner *ngIf="data.info == 'Name' && isChangingName"></mat-spinner>
                  <mat-spinner *ngIf="data.info == 'Owner' && isChangingOwner"></mat-spinner>
                  <mat-spinner *ngIf="data.info == 'Subscription' && isLoadingPortal"></mat-spinner>
                  <mat-spinner *ngIf="data.info == 'User' && isUpdatingUser"></mat-spinner>
                  <mat-icon matTooltip="Edit Name" *ngIf="data.info == 'Name' && !isChangingName && isOwner" (click)="changeName()">edit</mat-icon>
                  <mat-icon matTooltip="Edit Owner" *ngIf="data.info == 'Owner' && !isChangingOwner && isOwner" (click)="changeOwner()">edit</mat-icon>
                  <mat-icon matTooltip="Manage Subscription" *ngIf="data.info == 'Subscription' && !isLoadingPortal && isOwner" (click)="openCustomerPortal()">settings</mat-icon>
                  <mat-icon matTooltip="Manage User" *ngIf="data.info == 'User' && !isUpdatingUser" (click)="updateUser()">manage_accounts</mat-icon>
              </td>
            </ng-container>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <!-- <button class="delete-button" mat-raised-button *ngIf="!isLoading && isOwner" color="accent" (click)="deleteWorkspace()" disabled>Delete</button> -->
      <div class="loading-spinner" *ngIf="isLoading">
        <mat-spinner></mat-spinner>
      </div>
      <p><mat-icon (click)="getWorkspace()">sync</mat-icon> {{ lastSync | date: 'dd.MM.yyyy - HH:mm:ss' }}</p>
    </mat-card-content>
</mat-card>